import React from 'react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { useCountdown } from '../hooks/useCountdown';
import { TARGET_DATE } from '../data/content';
import { scrollToCheckout } from '../utils/scroll';
export function Countdown() {
  const {
    days,
    hours,
    minutes,
    seconds,
    done
  } = useCountdown(TARGET_DATE);
  const units = [{
    value: days,
    label: 'Días'
  }, {
    value: hours,
    label: 'Horas'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Seg'
  }];
  return <section aria-label="Cierre de inscripciones" className="border-y border-gold bg-ink px-6 py-12" data-id="element-29" data-mp="3h1qrhnqdeeed">
      <Reveal data-id="element-30" data-mp="324zxxv3dnwwo">
        <p className="text-center text-[15px] font-semibold leading-snug text-white" data-id="element-31" data-mp="325j5qizbd4wz">
          Cupo cerrado el 1 de octubre — inicio del diagnóstico en vivo
        </p>
        {done ? <p className="mt-8 text-center font-serif text-3xl font-bold text-gold" data-id="element-32" data-mp="10cuze0rdi1cz">Cupos cerrados</p> : <div className="mt-7 grid grid-cols-4 gap-2.5" role="timer" aria-live="off" data-id="element-33" data-mp="159c0dvjo8a7h">
            {units.map(u => <div key={u.label} className="flex flex-col items-center rounded-lg border border-gold/30 bg-panel py-4" data-id="element-34" data-mp="t23g9qq041j9">
                <span className="font-serif text-[32px] font-bold leading-none text-gold tabular-nums" data-id="element-35" data-mp="17q6lgxw7z970">
                  {String(u.value).padStart(2, '0')}
                </span>
                <span className="mt-2 text-[10px] font-semibold uppercase tracking-[0.18em] text-muted/70" data-id="element-36" data-mp="f33q2emubekz">
                  {u.label}
                </span>
              </div>)}
          </div>}
        <div className="mt-8" data-id="element-37" data-mp="o4bocwpcwff2">
          <CtaButton label="Reservar mi cupo" onClick={scrollToCheckout} data-id="element-38" data-mp="k1ezwpd4xp37" />
        </div>
      </Reveal>
    </section>;
}